import React, { useState, useEffect } from "react";
import Alert from '@mui/material/Alert';

const NtError = (props) => {
    const [useDisplay, setDisplay] = useState(props.testState);
    const styles = {
        position: 'fixed',
        right: '2%',
        bottom: '2%',
        borderRadius: '4px',
        padding: '8px 30px',
        fontWeight: 600,
        color: '#ffd0d0',
        zIndex: 9999
    }
    useEffect(()=> {
        setTimeout(() => {
            setDisplay('d-none')
        }, 5000)
    },[useDisplay]);
    //error
    //info
    //warning
    //success
    switch (props.errorType) {
        case 'noMetamask':
            return( 
                <Alert variant="filled" style={{...styles}} severity="error">
                    Error: No Metamask fond. Please install metamask or any other wallet.
                </Alert>
            )
            break; 
        case 'metamaskReject':
            return( 
                <Alert variant="filled" style={{...styles}} severity="error">
                    Transaction rejected by user.
                </Alert>
            )
            break; 
        case 'someThingelse':
            return( 
                <Alert variant="filled" style={{...styles}} severity="error">
                    Error: Something went worng. Please check your console or TRX.
                </Alert>
            )
            break;
        case 'wrongNetwork':
            return( 
                <Alert variant="filled" style={{...styles}} severity="error">
                    Error: Wronge Network selected. Please select Binance Smart Chain as your network.
                </Alert>
            )
            break;
        case 'maybeWrongNetwork':
            return( 
                <Alert variant="filled" style={{...styles}} severity="error">
                    Error: Maybe you have selected wronge network. Please select Binance Smart Chain as your network.
                </Alert>
            )
            break;
        case 'walletNotConnected':
            return( 
                <Alert variant="filled" style={{...styles}} severity="error">
                    Error: Wallet address is not connected.
                </Alert>
            )
            break;
        case 'walletChanged':
            return( 
                <Alert variant="filled" style={{...styles}} severity="info">
                    Wallet address changed successfully.
                </Alert>
            )
            break;
        default:
            return <span />
            break;
    }
    
}

export default NtError;